import { ChevronIcon } from "@theme/assets/icons/base";
import { MsButton, NavLink } from "@theme/index";
import { Box } from "theme-ui";

import type { NavCategory } from "@theme/index";
import type { RefObject } from "react";
import type { ThemeUIStyleObject } from "theme-ui";

interface NavMobileTopProps {
  navCategories: NavCategory[];
  categoryRefs: { current: RefObject<HTMLElement>[] };
  setIsDrawerOpen: (isDrawerOpen: boolean) => void;
  NavLinkTextStyles: ThemeUIStyleObject;
  showAccordion: (index: number) => void;
}

export const NavMobileTop = ({
  navCategories,
  categoryRefs,
  setIsDrawerOpen,
  NavLinkTextStyles,
  showAccordion,
}: NavMobileTopProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "s400" }}>
    {/* Shop All Category, we treat as a link */}
    {navCategories.map((navCategory, index) =>
      navCategory.isStaticLink ? (
        <NavLink
          ref={categoryRefs.current[index] as RefObject<HTMLAnchorElement>}
          data-testid={`mobile-nav-${navCategory.slug}`}
          key={index}
          variant="box"
          to={`${navCategory.pageSlug}`}
          tabIndex={0}
          aria-label={navCategory.title}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            variant: "text.sansBody03Regular",
            gap: "s400",
            ...NavLinkTextStyles,
          }}
          onClick={() => setIsDrawerOpen(false)}
        >
          {navCategory.title}
        </NavLink>
      ) : (
        <MsButton
          ref={categoryRefs.current[index] as RefObject<HTMLButtonElement>}
          data-testid={`mobile-nav-${navCategory.slug}`}
          variant="link"
          key={index}
          onClick={() => showAccordion(index)}
          tabIndex={0}
          aria-label={navCategory.title}
          aria-expanded={false}
          TrailingIcon={ChevronIcon}
          sx={{
            p: 0,
            span: {
              variant: "text.sansBody03Regular",
              justifyContent: "space-between",
              span: {
                ...NavLinkTextStyles,
              },
              svg: {
                height: "14px",
                color: "grey400",
              },
            },
          }}
        >
          {navCategory.title}
        </MsButton>
      ),
    )}
  </Box>
);
